import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title", "aria-label"]
const _hoisted_2 = {
  key: 1,
  class: "size-5 text-green-600",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "cursor-pointer",
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
    title: _ctx.copied ? 'คัดลอกแล้ว' : `คัดลอก${_ctx.label}`,
    "aria-label": `คัดลอก${_ctx.label}`
  }, [
    (!_ctx.copied)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          class: _normalizeClass(_ctx.iconClass),
          "aria-hidden": "true",
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          fill: "none",
          viewBox: "0 0 24 24"
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("path", {
            stroke: "currentColor",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M14 4v3a1 1 0 0 1-1 1h-3m4 10v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h2m11-3v10a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7.87a1 1 0 0 1 .24-.65l2.46-2.87a1 1 0 0 1 .76-.35H18a1 1 0 0 1 1 1Z"
          }, null, -1 /* HOISTED */)
        ]), 2 /* CLASS */))
      : (_openBlock(), _createElementBlock("svg", _hoisted_2, _cache[2] || (_cache[2] = [
          _createElementVNode("path", {
            d: "M20 6L9 17l-5-5",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, -1 /* HOISTED */)
        ])))
  ], 8 /* PROPS */, _hoisted_1))
}